import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';


const tasksSlice = createSlice({
  name: 'tasks',
  initialState: [],
  reducers: {
    addTask: (state, action) => {
      state.push({ id: uuidv4(), ...action.payload, completed: false });
    },
    toggleComplete: (state, action) => {
      const task = state.find(t => t.id === action.payload);
      if (task) task.completed = !task.completed;
    },
    deleteTask: (state, action) => {
      return state.filter(task => task.id !== action.payload);
    },

    updateTask: (state, action) => {
      const { id, title, dueDate, priority } = action.payload;
      const task = state.find(t => t.id === id);
      if (task) {
        task.title = title;
        task.dueDate = dueDate;
        task.priority = priority;
      }
    },

    clearCompletedTasks: (state) => {
      return state.filter(task => !task.completed);
    }



  }
});

export const { addTask, toggleComplete, deleteTask, updateTask, clearCompletedTasks } = tasksSlice.actions;

export default tasksSlice.reducer;